import { environment } from 'environments/environment';

import { Profilo } from './profilo';

export class StaticUrls {
	/* Pagamento Contratto */
	static pagamentoContrattoPubblicazione(idImmobile: number) {
		return environment.url_root + 'pagamento_contratto/pubblicazione/' + idImmobile;
	}
	static pagamentoContrattoServizi = environment.url_root + 'pagamento_contratto/servizi';
	/* Pay Pal */
	static creaPagamentoPP = environment.url_root + 'pagamento_pay_pal/crea_pagamento';
	static creaSubscriptionPP = environment.url_root + 'pagamento_pay_pal/crea_subscription';
	static acettaSubscriptionPP(token: string) {
		return environment.url_root + 'pagamento_pay_pal/accetta_subscription/' + token;
	}
	static cancellaSubscriptionPP(token: string) {
		return environment.url_root + 'pagamento_pay_pal/cancella_subscription/' + token;
	}
	/* Comune */
	static _getComune = environment.url_root + 'comune/';
	static _getComuniByProvincia = StaticUrls._getComune + 'by_provincia';
	static _checkComune(parametro: string): string {
		return StaticUrls._getComune + 'check/' + parametro;
	}
	/* BackOffice (Statistiche) */
	static _backoffice = environment.url_root + 'back_office';
	static _backofficeServizi(mese: number, anno: number) {
		return StaticUrls._backoffice + '/servizi?' +
			(anno != undefined ? 'anno=' + anno : '')
			+ (mese != undefined ? (anno != undefined ? '&' : '') + 'mese=' + mese : '');
	}
	static _backofficeImmobili(mese: number, anno: number) {
		return StaticUrls._backoffice + '/immobili?' +
			(anno != undefined ? 'anno=' + anno : '')
			+ (mese != undefined ? (anno != undefined ? '&' : '') + 'mese=' + mese : '');
	}
	static _backofficeUtenti(mese: number, anno: number) {
		return StaticUrls._backoffice + '/utenti?' +
			(anno != undefined ? 'anno=' + anno : '')
			+ (mese != undefined ? (anno != undefined ? '&' : '') + 'mese=' + mese : '');
	}
	/* Provincia */
	static _provincia = environment.url_root + 'provincia';
	/* Login */
	static _login = environment.url_root + 'auth/_login';
	/* Profilo */
	static _profilo = environment.url_root + 'profilo';
	static _updatePass = StaticUrls._profilo + '/update_pass';
	static _searchUtenti = StaticUrls._profilo + '/search';
	static _updateAccessoApp = StaticUrls._profilo + '/update_accesso_app';
	static _updateAccessoImmobile = StaticUrls._profilo + '/update_accesso_immobile';
	static _countUtenti = StaticUrls._profilo + '/count';
	static _checkUsername(parametro: string): string {
		return StaticUrls._profilo + '/check_username/' + parametro;
	}
	static _checkMail(parametro: string): string {
		return StaticUrls._profilo + '/check_email/' + parametro;
	}
	static _cancellazioneLogicaProfilo(id: number): string {
		return StaticUrls._profilo + '/cancellazione_logica/' + id;
	}
	/* Importo Profilo (Capacita spesa) */
	static _importoProfilo = StaticUrls._profilo + '/importo_massimo';
	static _importoProfiloById(id: number, importo: number) {
		return StaticUrls._importoProfilo + '/' + id + '/' + importo;
	}
	/* Anagrafica (Profilo: Agenzia, Costruttore,Privato e Azienda) */
	static _anagrafica = environment.url_root + 'anagrafica';
	static _anagraficaAutocomplete = StaticUrls._anagrafica + '/autocomplete';
	static _utentiNonRegistrati(profilo: Profilo) {
		const queryParams = [];
		if(profilo.idTipologia !== undefined && profilo.idTipologia !== null){
			queryParams.push('idTipologia=' + profilo.idTipologia);
		}
		if(profilo.anagrafica.mail !== undefined && profilo.anagrafica.mail !== null){
			queryParams.push('mail=' + profilo.anagrafica.mail);
		}
		if(profilo.anagrafica.cognome !== undefined && profilo.anagrafica.cognome !== null){
			queryParams.push('cognome=' + profilo.anagrafica.cognome);
		}
		const queryString ='?' + queryParams.join('&');
		return StaticUrls._anagrafica + '/excel' + (queryParams.length >0 ? queryString : '');
	};
	static _checkCF(parametro: string): string {
		return StaticUrls._anagrafica + '/check_cf/' + parametro;
	}
	static _checkPIva(parametro: string): string {
		return StaticUrls._anagrafica + '/check_p_iva/' + parametro;
	}
	/* Note Anagrafica */
	static _anagraficaNote = StaticUrls._anagrafica + '/nota';
	static _anagraficaNoteParam(id: number): string {
		return StaticUrls._anagraficaNote + '/' + id;
	}
	static _anagraficaNotaParam(id: number): string {
		return StaticUrls._anagraficaNote + '/get/' + id;
	}
	/* Preferenze Anagrafica */
	static _anagraficaPreferenza(preferenza: string): string {
		return StaticUrls._anagrafica + '/preferenza/' + preferenza;
	}
	/* Trascodifiche */
	static _trascodifica = environment.url_root + 'trascodifica';
	static _getTrascodifica(dominio: string, orderFieldName?: string): string {
		return StaticUrls._trascodifica + '/' + dominio
			+ (orderFieldName != undefined ? '?orderFieldName=' + orderFieldName : '');
	}
	static _getTrascodificaWithChildren(dominio: string, descrizione?: string): string {
		return StaticUrls._trascodifica + '/with_children?dominio=' + dominio
			+ (descrizione != undefined ? '&descrizione=' + descrizione : '');
	}
	static _getTrascodificaWithParent(dominio: string, descrizione?: string): string {
		return StaticUrls._trascodifica + '/with_parent?dominio=' + dominio
			+ (descrizione != undefined ? '&descrizione=' + descrizione : '');
	}
	static _getTrascodificaMore(orderFieldName?: string): string {
		return StaticUrls._trascodifica + '/more'
			+ (orderFieldName != undefined ? '?orderFieldName=' + orderFieldName : '');
	}
	static _getIdDominioAndDescrizione(dominio: string, descrizione: string): string {
		return StaticUrls._trascodifica + '/id/' + dominio + '/' + descrizione;
	}
	static _getTrascodificaById(id: number): string {
		return StaticUrls._trascodifica + '/get_by_id/' + id;
	}
	/* Servizi */
	static _servizio = environment.url_root + 'servizio';
	static _servizioSearch = StaticUrls._servizio + '/search';
	static _servizioSearchCliente = StaticUrls._servizio + '/search_cliente';
	static _servizioUpdateRating = StaticUrls._servizio + '/update_rating';
	static _servizioUpdateRatingComm = StaticUrls._servizio + '/update_rating_comm';
	static _servizioSetErogato = StaticUrls._servizio + '/update_erogato';
	static _servizioNonErogati = StaticUrls._servizio + '/num_servizi_non_erogati';
	static _servizioImmobileErogatiNoRating = StaticUrls._servizio + '/num_servizi_erogati';
	static _servizioImmobileRigetta = StaticUrls._servizio + '/rigetta';
	static _servizioScadenziario = StaticUrls._servizio + '/search_scadenziario';
	static _servizioNumErogatiInScadenza = StaticUrls._servizio + '/num_erogati_scadenza';
	static _servizioSetCollaboratorePagato = StaticUrls._servizio + '/collaboratore_pagato';
	static _checkDispServizio(comune: string, cap: string, tipoPosizione: string): string {
		return StaticUrls._servizio + '/' + comune + '/' + cap + '/' + tipoPosizione;
	}
	static _servizioGetNonPagati = StaticUrls._servizio + '/get_non_pagati';
	static _servizioCountNonPagati = StaticUrls._servizio + '/count_non_pagati';
	static _servizio_get_by_immobile_short(idImmobile: number) {
		return StaticUrls._servizio + '/get_by_immobile_short/' + idImmobile;
	}
	static _getServizioById(id: number): string {
		return StaticUrls._servizio + '/get_by_id/' + id;
	}
	/* Servizio Venditore */
	static _servizioVenditore = environment.url_root + 'servizio_venditore';
	static _getServizioByDD(dominio: string, descrizione: string): string {
		return StaticUrls._servizioVenditore + '/get' + '?dominio=' + dominio + '&descrizione=' + descrizione;
	}
	static _servizioPubblicazione(idImmobile: number): string {
		return StaticUrls._servizioVenditore + '/pubblicazione' + '?idImmobile=' + idImmobile;
	}
	static _getCostoServizio(idTipologiaServizio: number, codice: string): string {
		return StaticUrls._servizioVenditore + '/get_costo_servizio/' + idTipologiaServizio + '/' + codice;
	}
	static _getServizioByParentDD(dominio: string, descrizione: string): string {
		return StaticUrls._servizioVenditore + '/get_by_parent' + '?dominio=' + dominio + '&descrizione=' + descrizione;
	}
	static _getServizioByDominio(dominio: string): string {
		return StaticUrls._servizioVenditore + '/' + dominio;
	}
	/* Servizio Acquirente */
	static _servizioAcquirente = environment.url_root + 'servizio_acquirente';
	/* Immobile */
	static _immobile = environment.url_root + 'immobile';
	static _insertParziale = StaticUrls._immobile + '/insert_parziale';
	static _updatePubblicato = StaticUrls._immobile + '/update_pubblicato';
	static _searchImmobile = StaticUrls._immobile + '/search';
	static _countSearchImmobile = StaticUrls._immobile + '/count_search';
	static _searchImmobileAmministrazione = StaticUrls._immobile + '/search_amministrazione';
	static _countSearchImmobileAmministrazione = StaticUrls._immobile + '/count_search_amministrazione';
	static _immobileShort = StaticUrls._immobile + '/short';
	static _saveImmobilePreferito = StaticUrls._immobile + '/preferito/insert';
	static _getImmobiliPreferiti = StaticUrls._immobile + '/preferito_get';
	static _countImmobiliPreferiti = StaticUrls._immobile + '/preferito_count';
	static _getMyImmobili = StaticUrls._immobile + '/my_get';
	static _countMyImmobili = StaticUrls._immobile + '/my_count';
	static _deleteImmobilePreferito = StaticUrls._immobile + '/preferito/delete';
	static _checkImmobilePreferito = StaticUrls._immobile + '/preferito/check';
	static _searchImmobileUpdateStato = StaticUrls._immobile + '/update_stato';
	static _elimina = StaticUrls._immobile + '/elimina';
	static _cancellazione = StaticUrls._immobile + '/cancellazione';
	static _searchImmobileUpdateSospeso = StaticUrls._immobile + '/update_sospeso';
	static _checkImmobile(parametro: number): string {
		return StaticUrls._immobile + '/check/' + parametro;
	}
	/* Ricerche Salvate Immobile */
	static _ricercheSalvate = StaticUrls._immobile + '/search_immobile_ricerca';
	static _deleteRicercheSalvate(id: number) { return StaticUrls._immobile + '/delete_immobile_ricerca/' + id; }
	/* Impostazioni */
	static _impostazioni = environment.url_root + 'impostazioni';
	static _impostazioniServizi = StaticUrls._impostazioni + '/def_servizi';
	static _impostazioniSconti = StaticUrls._impostazioni + '/sconti';
	static _impostazioniScontoProfilo = StaticUrls._impostazioni + '/sconto_profilo';
	static _impostazioniScontoUtente = StaticUrls._impostazioni + '/sconto_utente';
	static _impostazioniScontoPubblicazione = StaticUrls._impostazioni + '/sconto_pubblicazione';
	static _impostazioniScontiXls = StaticUrls._impostazioniSconti + '/xls';
	static _impostazioniScontiQuery(tipo: string) {
		return StaticUrls._impostazioniSconti + '?tipo=' + tipo;
	}
	static _impostazioniDeleteScontoUtente(id: number) {
		return StaticUrls._impostazioniScontoUtente + '/' + id;
	}
	static _impostazioniTestEmail = StaticUrls._impostazioni + '/test_mail';
	static _impostazioniEmailTemplates = StaticUrls._impostazioni + '/template_email';
	static _impostazioniProfili = StaticUrls._impostazioni + '/profili';
	static _impostazioniEmail = StaticUrls._impostazioni + '/impostazioni_email';
	static _impostazioniFtp = StaticUrls._impostazioni + '/impostazioni_ftp';
	/* Template Emails */
	static _getEmailTemplate(idTipologia: number) {
		return environment.url_root + 'email_template/' + idTipologia;
	}
	/* File */
	static _file = environment.url_root + 'file/';
	static _collaboratoreUploadContratto(id: number) {
		return StaticUrls._file + 'upload_contratto_candidato/' + id;
	}
	static _cvCandidato(parametro: string): string {
		return StaticUrls._file + 'upload_cv_candidato/' + parametro;
	}
	static _vcCandidato(parametro: string): string {
		return StaticUrls._file + 'upload_vc_candidato/' + parametro;
	}
	static _contrattoUtente(parametro: string): string {
		return StaticUrls._file + 'upload_contratto_utente/' + parametro;
	}
	static _documentoIdentitaUtente(parametro: string): string {
		return StaticUrls._file + 'upload_doc_identita_utente/' + parametro;
	}

	static _documentoVisuraCamerale(parametro: string): string {
		return StaticUrls._file + 'upload_visura_camerale_utente/' + parametro;
	}
	static _immobileDocumenti(idImmobile: number, idTipologiaDocumento: number) {
		return StaticUrls._file + 'upload_documenti_immobile?idImmobile=' + idImmobile + '&idTipologiaDocumento=' + idTipologiaDocumento;
	}
	static _immobileDocumentiObbligatori(idImmobile: number, idTipologiaDocumento: number, idDatoCatastale: number) {
		return StaticUrls._file + 'upload_documenti_immobile_obbligatori?idImmobile=' + idImmobile +
			'&idTipologiaDocumento=' + idTipologiaDocumento + '&idDatoCatastale=' + idDatoCatastale;
	}
	static _immobileDocumentoCertificazionePrestazioneEnergetica(idImmobile: number, idDatoCatastale: number) {
		return StaticUrls._file + 'upload_documento_prestazione_energetica?idImmobile=' + idImmobile +
			'&idDatoCatastale=' + idDatoCatastale;
	}
	static _deleteDocumentoImmobile(idDocumento: number) {
		return StaticUrls._file + 'delete_documento_immobile?idDocumento=' + idDocumento;
	}
	static _deleteDocumentoImmobileObbligatorio(idDocumento: number, idDatoCatastale: number) {
		return StaticUrls._file + 'delete_documento_immobile_obbligatorio?idDocumento=' + idDocumento + '&idDatoCatastale=' + idDatoCatastale;
	}
	static _servizioUploadFattura(idServizio: number) {
		return StaticUrls._file + 'upload_fattura_servizio?idServizio=' + idServizio;
	}
	static _immobileFoto(parametro: any) {
		return StaticUrls._file + 'upload_foto_immobile/' + parametro;
	}
	static _immobileVideo(parametro: any) {
		return StaticUrls._file + 'upload_video_vimeo/' + parametro;
	}
	static _deleteVimeoVideo(parametro: any) {
		return StaticUrls._file + 'delete_video_vimeo/' + parametro;
	}
	static _immobilePlanimetria(parametro: any) {
		return StaticUrls._file + 'upload_planimetria_immobile/' + parametro;
	}
	static _deleteFotoImmobile(idImmobile: number, nomeFoto: string) {
		return StaticUrls._file + 'delete_foto_immobile/' + idImmobile + '/' + nomeFoto;
	}
	static _deletePlanimetriaImmobile(idImmobile: number, nomeFoto: string) {
		return StaticUrls._file + 'delete_planimetria_immobile/' + idImmobile + '/' + nomeFoto;
	}
	static _deleteDocumentoIdentitaUtente(parametro: string): string {
		return StaticUrls._file + 'delete_doc_identita_utente/' + parametro;
	}
	static _deleteVisuraCameraleUtente(parametro: string): string {
		return StaticUrls._file + 'delete_visura_camerale_utente/' + parametro;
	}
	static _deleteCv(id: number): string {
		return StaticUrls._file + 'delete_cv_collaboratore/' + id;
	}
	static _deleteVc(id: number): string {
		return StaticUrls._file + 'delete_vc_collaboratore/' + id;
	}
	static _deleteContratto(id: number): string {
		return StaticUrls._file + 'delete_contratto_collaboratore/' + id;
	}
	static _deleteDocumentoRichiesta(id: number): string {
		return StaticUrls._file + 'delete_doc_richiesta_mutuo/' + id;
	}
	/* Collaboratore */
	static _collaboratore = environment.url_root + 'collaboratore';
	static _searchCollaboratore = StaticUrls._collaboratore + '/search';
	static _countCollaboratoriNuovi = StaticUrls._collaboratore + '/count_nuovi';
	static _countCollaboratoriDaConfermare = StaticUrls._collaboratore + '/count_da_confermare';
	static _collaboratoreById(id: number) {
		return StaticUrls._collaboratore + '/by_id/' + id;
	}
	static _collaboratoreUpdateStato(id: number, stato: string) {
		return StaticUrls._collaboratore + '/update_stato/' + id + '/' + stato;
	}
	static _collaboratoreSetConfermato(id: number) {
		return StaticUrls._collaboratore + '/update_confermato/' + id;
	}
	static _delete(id: number) {
		return StaticUrls._collaboratore + '/' + id;
	}
	static _searchCollaboratoreXls(idStato: number, idTipologiaPosizione) {
		return StaticUrls._collaboratore + '/xls?' +
			(idStato != undefined && idStato != null ? 'idStato=' + idStato : '')
			+ (idTipologiaPosizione != undefined && idTipologiaPosizione != null ?
				(idStato != undefined && idStato != null ? '&' : '') + 'idTipologiaPosizione=' + idTipologiaPosizione : '');
	}
	/* Messaggi */
	static _messaggio = environment.url_root + 'messaggio';
	static _messaggio_prenotazione = StaticUrls._messaggio + '/prenotazione';
	static _messaggio_conferma = StaticUrls._messaggio + '/conferma';
	static _short_nl = StaticUrls._messaggio + '/short_nl';
	static _ricevuti = StaticUrls._messaggio + '/ricevuti';
	static _inviati = StaticUrls._messaggio + '/inviati';
	static _archiviati = StaticUrls._messaggio + '/archiviati';
	static _msg_archivia = StaticUrls._messaggio + '/archiviato';
	static _msgCount(letto: boolean) {
		return StaticUrls._messaggio + '/count/' + letto;
	}
	static _msgCheckLetto(id: number) {
		return StaticUrls._messaggio + '/check_letto/' + id;
	}
	/* Orario */
	static _orario = environment.url_root + 'orario';
	static _orario_num_pross_ap = StaticUrls._orario + '/num_appuntamenti';
	/* Cap */
	static _cap = environment.url_root + 'cap/';
	static _getCapByComuni = StaticUrls._cap + 'by_comune';
	static _capCheck(cap, comune) {
		return StaticUrls._cap + cap + '/' + comune;
	}
	/* Blocco immobile */
	static _bloccoImmobile = environment.url_root + 'blocco_immobile';
	static _bloccoImmobileSearchEffettuati = StaticUrls._bloccoImmobile + '/search_effettuati';
	static _bloccoImmobileCountSearchEffettuati = StaticUrls._bloccoImmobile + '/count_search_effettuati';
	static _bloccoImmobileSearchRicevuti = StaticUrls._bloccoImmobile + '/search_ricevuti';
	static _bloccoImmobileCountSearchRicevuti = StaticUrls._bloccoImmobile + '/count_search_ricevuti';
	static _bloccoImmobileCountSearchRicevutiInAttesa = StaticUrls._bloccoImmobile + '/count_search_ricevuti_in_attesa';
	static _bloccoImmobileApprova = StaticUrls._bloccoImmobile + '/approva';
	static _bloccoImmobileRifiuta = StaticUrls._bloccoImmobile + '/rifiuta';
	/* Pagamenti */
	static _pagamento = environment.url_root + 'pagamento';
	static _pagamento_click = StaticUrls._pagamento + '_one_click/pay';
	static _pagamento_ricorrente = StaticUrls._pagamento + '_ricorrente/pay';
	static _pagamento_semplice = StaticUrls._pagamento + '_semplice/pay';
	/* Reset password */
	static _reset_pass = environment.url_root + 'reset_password';
	static _richiesta_reset_pass = StaticUrls._reset_pass + '/_request';
	static _check_reset_token = StaticUrls._reset_pass + '/_check_token';
	static _update_password = StaticUrls._reset_pass + '/_update_password';
	/* Richiesta mutuo */
	static richiesta_mutuo = environment.url_root + 'richiesta_mutuo/';
	static richiesta_mutuo_update_stato = StaticUrls.richiesta_mutuo + 'update_stato';
	static richiesta_mutuo_inoltra = StaticUrls.richiesta_mutuo + 'inoltra';
	static richiesta_mutuo_inoltra_na = StaticUrls.richiesta_mutuo + 'inoltra_na';
	static richiesta_mutuo_insert_na = StaticUrls.richiesta_mutuo + 'insert_na';
	static richiesta_mutuo_search = StaticUrls.richiesta_mutuo + 'search';
	static richiesta_mutuo_search_my = StaticUrls.richiesta_mutuo + 'search_my';
	static richiesta_mutuo_search_count = StaticUrls.richiesta_mutuo + 'count_search';
	static richiesta_mutuo_search_count_my = StaticUrls.richiesta_mutuo + 'count_search_my';
	static richiesta_mutuo_json_file = StaticUrls.richiesta_mutuo + 'download_json';
	static richiesta_mutuo_csv_file = StaticUrls.richiesta_mutuo + 'download_csv';
	static richiesta_mutuo_email = StaticUrls.richiesta_mutuo + 'email';
	static richiesta_mutuo_mediatore = StaticUrls.richiesta_mutuo + 'mediatore';
	static richiesta_mutuo_by_id(id: number) { return StaticUrls.richiesta_mutuo + id; }
	static richiesta_mutuo_doc(idRichiesta: number, idTipologiaDocumento: number) {
		return StaticUrls._file + 'upload_documenti_richiesta?idRichiesta=' + idRichiesta + '&idTipologiaDocumento=' + idTipologiaDocumento;
	}
	static richiesta_mutuo_doc_richiedente(idRichiesta: number, idRichiedente: number, idTipologiaDocumento: number) {
		return StaticUrls._file + 'upload_documenti_richiesta_richiedente?idRichiesta=' + idRichiesta + '&idRichiedente=' + idRichiedente 
						+ '&idTipologiaDocumento=' + idTipologiaDocumento;
	}
	static richiesta_mutuo_doc_na(idRichiesta: number, idTipologiaDocumento: number) {
		return StaticUrls._file + 'upload_documenti_richiesta_na?idRichiesta=' + idRichiesta + '&idTipologiaDocumento=' + idTipologiaDocumento;
	}
	static richiesta_mutuo_doc_richiedente_na(idRichiesta: number, idRichiedente: number, idTipologiaDocumento: number) {
		return StaticUrls._file + 'upload_documenti_richiesta_richiedente_na?idRichiesta=' + idRichiesta + '&idRichiedente=' + idRichiedente 
						+ '&idTipologiaDocumento=' + idTipologiaDocumento;
	}
	static richiesta_mutuo_get_doc_richiesta(idRichiesta: number, idTipologiaDocumento: number) {
		return StaticUrls.richiesta_mutuo + 'get_doc_richiesta/' + idRichiesta + '/' + idTipologiaDocumento;
	}
	static richiesta_mutuo_get_doc_richiedente(idRichiesta: number, idRichiedente: number, idTipologiaDocumento: number) {
		return StaticUrls.richiesta_mutuo + 'get_doc_richiesta_richiedente/' + idRichiesta + '/' + idRichiedente 
						+ '/' + idTipologiaDocumento;
	}
	static richiesta_mutuo_delete_intestatario(id: number) {
		return StaticUrls.richiesta_mutuo + 'delete_intestatario/' + id;
	}
	static richiesta_mutuo_delete_impegno(id: number) {
		return StaticUrls.richiesta_mutuo + 'delete_impegno/' + id;
	}
	static richiesta_mutuo_count(stato: string): string {
		return StaticUrls.richiesta_mutuo + 'count/' + stato;
	}
	
}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/static-urls.ts